// ===================================================
// RELATÓRIO DE ESTOQUE
// ===================================================
function renderRelEstoque(){
  const estoque = DB.get('estoque');
  const el = document.getElementById('re-content');
  if(!el) return;

  const totalM2 = estoque.reduce((s,e)=>s+(e.totalM2||0),0);
  const dispM2 = estoque.reduce((s,e)=>s+(e.disponivelM2||0),0);
  const valorTotal = estoque.reduce((s,e)=>s+(e.disponivelM2||0)*(e.precoM2||0),0);
  const abaixoMin = estoque.filter(e=>e.disponivelM2<e.minimoM2);

  el.innerHTML = `
    <div class="cards" style="margin-bottom:20px">${[
      {label:'Total em estoque',val:totalM2.toFixed(1)+' m²',icon:'📦',color:'#6c63ff'},
      {label:'Disponível',val:dispM2.toFixed(1)+' m²',icon:'✅',color:'#00d4aa'},
      {label:'Valor total',val:fmtMoney(valorTotal),icon:'💰',color:'#ffa94d'},
      {label:'Abaixo do mínimo',val:abaixoMin.length,icon:'⚠️',color:abaixoMin.length?'#f06595':'var(--muted)'},
    ].map(c=>`<div class="card"><div class="card-icon" style="color:${c.color}">${c.icon}</div><div class="card-val">${c.val}</div><div class="card-label">${c.label}</div></div>`).join('')}</div>

    ${abaixoMin.length?`<div style="background:#f0659511;border:1px solid #f06595;border-radius:12px;padding:14px;margin-bottom:16px">
      <div style="font-weight:700;color:#f06595;margin-bottom:8px">⚠️ Materiais abaixo do estoque mínimo</div>
      ${abaixoMin.map(e=>`<div style="display:flex;justify-content:space-between;padding:6px 0;border-bottom:1px solid #f0659522;font-size:13px">
        <span>${escapeHtml(e.material)}${e.cor?' — '+escapeHtml(e.cor):''}</span>
        <span><b style="color:#f06595">${(e.disponivelM2||0).toFixed(1)} m²</b> / mín. ${e.minimoM2} m²</span>
      </div>`).join('')}
    </div>`:''}

    <div style="background:var(--surface);border:1px solid var(--border);border-radius:12px;overflow:hidden">
      <table style="width:100%;border-collapse:collapse;font-size:13px">
        <thead><tr style="background:var(--bg);border-bottom:2px solid var(--border)">
          <th style="padding:10px 14px;text-align:left">Material</th>
          <th style="padding:10px;text-align:center">Espessura</th>
          <th style="padding:10px;text-align:center">Chapas</th>
          <th style="padding:10px;text-align:right">Total m²</th>
          <th style="padding:10px;text-align:right">Reservado</th>
          <th style="padding:10px;text-align:right">Disponível</th>
          <th style="padding:10px;text-align:right">R$/m²</th>
          <th style="padding:10px;text-align:right">Valor total</th>
          <th style="padding:10px;text-align:left">Fornecedor</th>
        </tr></thead>
        <tbody>${estoque.length?estoque.sort((a,b)=>a.material.localeCompare(b.material)).map(e=>{
          const alerta = e.disponivelM2<e.minimoM2;
          const chapasDisp = (e.chapas||[]).filter(c=>c.status==='disponivel').length;
          return `<tr style="border-bottom:1px solid var(--border);${alerta?'background:#f0659508':''}">
            <td style="padding:10px 14px;font-weight:600">${escapeHtml(e.material)}${e.cor?' <span style="color:var(--muted);font-weight:400">'+escapeHtml(e.cor)+'</span>':''}${alerta?' <span style="color:#f06595;font-size:11px">⚠</span>':''}</td>
            <td style="padding:10px;text-align:center;color:var(--muted)">${e.espessura||'—'}</td>
            <td style="padding:10px;text-align:center">${chapasDisp}</td>
            <td style="padding:10px;text-align:right">${(e.totalM2||0).toFixed(1)}</td>
            <td style="padding:10px;text-align:right;color:#ffa94d">${(e.reservadoM2||0).toFixed(1)}</td>
            <td style="padding:10px;text-align:right;font-weight:700;color:${alerta?'#f06595':'#00d4aa'}">${(e.disponivelM2||0).toFixed(1)}</td>
            <td style="padding:10px;text-align:right;color:var(--muted)">${e.precoM2?fmtMoney(e.precoM2):'—'}</td>
            <td style="padding:10px;text-align:right;font-weight:600">${e.precoM2?fmtMoney((e.disponivelM2||0)*e.precoM2):'—'}</td>
            <td style="padding:10px;font-size:11px;color:var(--muted)">${escapeHtml(e.fornecedor||'—')}</td>
          </tr>`;
        }).join(''):`<tr><td colspan="9" style="padding:32px;text-align:center;color:var(--muted)">Nenhum material cadastrado no estoque</td></tr>`}
        </tbody>
        <tfoot><tr style="background:var(--bg);border-top:2px solid var(--border);font-weight:700">
          <td colspan="3" style="padding:10px 14px">TOTAL</td>
          <td style="padding:10px;text-align:right">${totalM2.toFixed(1)}</td>
          <td style="padding:10px;text-align:right;color:#ffa94d">${estoque.reduce((s,e)=>s+(e.reservadoM2||0),0).toFixed(1)}</td>
          <td style="padding:10px;text-align:right;color:#00d4aa">${dispM2.toFixed(1)}</td>
          <td></td>
          <td style="padding:10px;text-align:right;color:#ffa94d">${fmtMoney(valorTotal)}</td>
          <td></td>
        </tr></tfoot>
      </table>
    </div>

    ${estoque.some(e=>e.chapas?.length)?`
    <div style="margin-top:20px">
      <div style="font-weight:700;font-size:15px;margin-bottom:12px">Detalhe por chapa</div>
      ${estoque.filter(e=>e.chapas?.length).map(e=>`
        <div style="margin-bottom:16px">
          <div style="font-weight:600;font-size:14px;margin-bottom:8px;color:var(--accent)">${escapeHtml(e.material)}${e.cor?' — '+escapeHtml(e.cor):''}</div>
          <table style="width:100%;border-collapse:collapse;font-size:12px;background:var(--surface);border:1px solid var(--border);border-radius:8px;overflow:hidden">
            <thead><tr style="background:var(--bg)"><th style="padding:7px 12px;text-align:left">Nº</th><th style="padding:7px;text-align:right">Larg (cm)</th><th style="padding:7px;text-align:right">Alt (cm)</th><th style="padding:7px;text-align:right">m²</th><th style="padding:7px;text-align:center">Status</th></tr></thead>
            <tbody>${e.chapas.map(c=>`<tr style="border-top:1px solid var(--border)">
              <td style="padding:7px 12px">${c.numero||'—'}</td>
              <td style="padding:7px;text-align:right">${c.largura||'—'}</td>
              <td style="padding:7px;text-align:right">${c.altura||'—'}</td>
              <td style="padding:7px;text-align:right;font-weight:600">${c.m2}</td>
              <td style="padding:7px;text-align:center"><span style="font-size:11px;padding:2px 8px;border-radius:20px;background:${c.status==='disponivel'?'#00d4aa22':c.status==='reservado'?'#ffa94d22':'#88888822'};color:${c.status==='disponivel'?'#00d4aa':c.status==='reservado'?'#ffa94d':'#888'}">${c.status==='disponivel'?'Disponível':c.status==='reservado'?'Reservado':'Cortado'}</span></td>
            </tr>`).join('')}</tbody>
          </table>
        </div>`).join('')}
    </div>`:''}`;
}

